"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType["dailyPoll"] = "dailyPoll";
    ContentType["similarity"] = "similarity";
    ContentType["dailyReflection"] = "dailyReflection";
    ContentType["compatibilitySnippet"] = "compatibilitySnippet";
    ContentType["post"] = "post";
    ContentType["resultSnippet"] = "resultSnippet";
    ContentType["archetype"] = "archetype";
    ContentType["story"] = "story";
    ContentType["personalityAnalysis"] = "personalityAnalysis";
    ContentType["report"] = "report";
    ContentType["compatibility"] = "compatibility";
    ContentType["natureBreakdown"] = "natureBreakdown";
    ContentType["dimensionSummary"] = "dimensionSummary";
    ContentType["comparisonSpectrum"] = "comparisonSpectrum";
    ContentType["peerRatedSpectrum"] = "peerRatedSpectrum";
    ContentType["publicProfile"] = "publicProfile";
    ContentType["deliveredDailyInsight"] = "deliveredDailyInsight";
    ContentType["userPoll"] = "userPoll";
    ContentType["deliveredDailyStory"] = "deliveredDailyStory";
    ContentType["periodicQuiz"] = "periodicQuiz";
    ContentType["sharedPost"] = "sharedPost";
    ContentType["communityQuestion"] = "communityQuestion";
    ContentType["peerStory"] = "peerStory";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
